export class ScheduleConfiguration {
    public scheduleInterval: ScheduleInterval;
    public formattedDate: string;
}

export enum ScheduleInterval {
    INSIDE = 'INSIDE',
    OUTSIDE = 'OUTSIDE'
}
